import { atom } from 'recoil';

export const giftStoreNavBarTitleAtom = atom<string>({
  key: 'giftStoreNavBarTitleAtom',
  default: '',
});

export const giftStoreNavBarUseAtom = atom<boolean>({
  key: 'giftStoreNavBarUseAtom',
  default: true,
});

export const giftStoreNavBackUrlAtom = atom<string>({
  key: 'giftStoreNavBackUrlAtom',
  default: '',
});

// 투명 모드 (상세페이지용)
export const giftStoreNavBarTransparentAtom = atom<boolean>({
  key: 'giftStoreNavBarTransparentAtom',
  default: false,
});

// 스크롤되어 헤더가 solid 상태인지 (상세페이지용)
export const giftStoreNavBarScrolledAtom = atom<boolean>({
  key: 'giftStoreNavBarScrolledAtom',
  default: false,
});
